import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/index'
  },
  {
    path: '/index',
    meta: {
      title: '常州贵研科技有限公司',
    },
    component: () => import(/* webpackChunkName: "index" */ '../views/indexView.vue'),
    children: [
      {
        path: '', // 默认子路由
        redirect: 'home' // 重定向到 'home' 子路由
      },
      {
        path: 'home',
        name: 'home',
        meta: {
          title: '常州贵研科技有限公司',
        },
        component: () => import(/* webpackChunkName: "home" */ '../views/homePage.vue'),
      },
      {
        path: 'aboutUs',
        name: 'aboutUs',
        meta: {
          title: '关于我们--常州贵研科技有限公司',
        },
        component: () => import(/* webpackChunkName: "aboutUs" */ '../views/aboutUs.vue'),
      },
  
      {
        path: 'productDisplay',
        name: 'productDisplay',
        meta: {
          title: '产品展示--常州贵研科技有限公司',
        },
        component: () => import(/* webpackChunkName: "productDisplay" */ '../views/productDisplay.vue'),
      },
      {
        path: 'companyNews',
        name: 'companyNews',
        meta: {
          title: '公司新闻--常州贵研科技有限公司',
        },
        component: () => import(/* webpackChunkName: "companyNews" */ '../views/companyNews.vue'),
      },
      {
        path: 'custFeedback',
        name: 'custFeedback',
        meta: {
          title: '客户反馈--常州贵研科技有限公司',
        },
        component: () => import(/* webpackChunkName: "custFeedback" */ '../views/custFeedback.vue'),
      },
      {
        path: 'contactUs',
        name: 'contactUs',
        meta: {
          title: '联系我们--常州贵研科技有限公司',
        },
        component: () => import(/* webpackChunkName: "contactUs" */ '../views/contactUs.vue'),
      },
      {
        path: 'product/display1',
        name: 'sharedDetails1',
        meta: {
          title: '产品展示--常州贵研科技有限公司',
        },
        component: () => import(/* webpackChunkName: "sharedDetails1" */ '../views/detailsPage/sharedDetails1.vue'),
      },
      {
        path: 'product/display2',
        name: 'sharedDetails2',
        meta: {
          title: '产品展示--常州贵研科技有限公司',
        },
        component: () => import(/* webpackChunkName: "sharedDetails2" */ '../views/detailsPage/sharedDetails2.vue'),
      },
      {
        path: 'product/display3',
        name: 'sharedDetails3',
        meta: {
          title: '产品展示--常州贵研科技有限公司',
        },
        component: () => import(/* webpackChunkName: "sharedDetails3" */ '../views/detailsPage/sharedDetails3.vue'),
      },
      {
        path: 'product/display4',
        name: 'sharedDetails4',
        meta: {
          title: '产品展示--常州贵研科技有限公司',
        },
        component: () => import(/* webpackChunkName: "sharedDetails4" */ '../views/detailsPage/sharedDetails4.vue'),
      },
      {
        path: 'product/display5',
        name: 'sharedDetails5',
        meta: {
          title: '产品展示--常州贵研科技有限公司',
        },
        component: () => import(/* webpackChunkName: "sharedDetails5" */ '../views/detailsPage/sharedDetails5.vue'),
      },
      {
        path: 'product/display6',
        name: 'sharedDetails6',
        meta: {
          title: '产品展示--常州贵研科技有限公司',
        },
        component: () => import(/* webpackChunkName: "sharedDetails6" */ '../views/detailsPage/sharedDetails6.vue'),
      },
      {
        path: 'product/display7',
        name: 'sharedDetails7',
        meta: {
          title: '产品展示--常州贵研科技有限公司',
        },
        component: () => import(/* webpackChunkName: "sharedDetails7" */ '../views/detailsPage/sharedDetails7.vue'),
      },
      {
        path: 'product/display8',
        name: 'sharedDetails8',
        meta: {
          title: '产品展示--常州贵研科技有限公司',
        },
        component: () => import(/* webpackChunkName: "sharedDetails8" */ '../views/detailsPage/sharedDetails8.vue'),
      },
      {
        path: 'product/display9',
        name: 'sharedDetails9',
        meta: {
          title: '产品展示--常州贵研科技有限公司',
        },
        component: () => import(/* webpackChunkName: "sharedDetails9" */ '../views/detailsPage/sharedDetails9.vue'),
      },
      {
        path: 'product/display10',
        name: 'sharedDetails10',
        meta: {
          title: '产品展示--常州贵研科技有限公司',
        },
        component: () => import(/* webpackChunkName: "sharedDetails10" */ '../views/detailsPage/sharedDetails10.vue'),
      },
      {
        path: 'product/display11',
        name: 'sharedDetails11',
        meta: {
          title: '产品展示--常州贵研科技有限公司',
        },
        component: () => import(/* webpackChunkName: "sharedDetails11" */ '../views/detailsPage/sharedDetails11.vue'),
      },
      {
        path: 'product/display12',
        name: 'sharedDetails12',
        meta: {
          title: '产品展示--常州贵研科技有限公司',
        },
        component: () => import(/* webpackChunkName: "sharedDetails12" */ '../views/detailsPage/sharedDetails12.vue'),
      },
      {
        path: 'product/display13',
        name: 'sharedDetails13',
        meta: {
          title: '产品展示--常州贵研科技有限公司',
        },
        component: () => import(/* webpackChunkName: "sharedDetails13" */ '../views/detailsPage/sharedDetails13.vue'),
      },
      {
        path: 'product/display14',
        name: 'sharedDetails14',
        meta: {
          title: '产品展示--常州贵研科技有限公司',
        },
        component: () => import(/* webpackChunkName: "sharedDetails14" */ '../views/detailsPage/sharedDetails14.vue'),
      },
      {
        path: 'product/display15',
        name: 'sharedDetails15',
        meta: {
          title: '产品展示--常州贵研科技有限公司',
        },
        component: () => import(/* webpackChunkName: "sharedDetails15" */ '../views/detailsPage/sharedDetails15.vue'),
      },
      {
        path: 'product/display16',
        name: 'sharedDetails16',
        meta: {
          title: '产品展示--常州贵研科技有限公司',
        },
        component: () => import(/* webpackChunkName: "sharedDetails16" */ '../views/detailsPage/sharedDetails16.vue'),
      },
      {
        path: 'product/display17',
        name: 'sharedDetails17',
        meta: {
          title: '产品展示--常州贵研科技有限公司',
        },
        component: () => import(/* webpackChunkName: "sharedDetails17" */ '../views/detailsPage/sharedDetails17.vue'),
      },
      {
        path: 'product/display18',
        name: 'sharedDetails18',
        meta: {
          title: '产品展示--常州贵研科技有限公司',
        },
        component: () => import(/* webpackChunkName: "sharedDetails18" */ '../views/detailsPage/sharedDetails18.vue'),
      },
    ],
  },

]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router
